/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Photo_Save_FailedInputs */

const en_profile_photo_save_failed = /** @type {(inputs: Profile_Photo_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save your profile. Please try again.`)
};

const pt_br2_profile_photo_save_failed = /** @type {(inputs: Profile_Photo_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível salvar seu perfil. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Could not save your profile. Please try again." |
*
* @param {Profile_Photo_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_photo_save_failed = /** @type {((inputs?: Profile_Photo_Save_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Photo_Save_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_photo_save_failed(inputs)
	return pt_br2_profile_photo_save_failed(inputs)
});